window.GMap ?= {}

GMap.vent = require('../helpers/events').vent
GMap.Markers = require '../markers'

GMap.View = Backbone.View.extend
  events:
    'click .static-map': 'changeToDynamic'

  initialize: ->
    {@mapOptions, @markerData, @staticMaps} = @options
    $body = $(document.body)
    @$locationsModal = $('#locations')
    @$staticMap = @$el.find('.static-map').add @$locationsModal.find 'static-map'
    @$dynamicMap = @$el.find('.dynamic-map').add @$locationsModal.find 'dynamic-map'

    GMap.vent.on('start', => @start())
    @isLocationsPopupWasActivated = false
    @isDynamicMapsWasActivated = false
    $body.on("modal-open:locations", => @onLocationsPopupOpen())

  changeToDynamic: ->
    Groupon.Utils.GoogleMaps.load (err) ->
      return if err?
      GMap._start()

    false

  start: ->
    GMap.vent.off('start')
    @googleMaps ?= window.google.maps

    unless @$locationsModal.hasClass 'show-modal'
      @$locationsModal.css
        display: 'block'
        visibility: 'hidden'

    if map = @createDynamicMap @mapOptions
      @markerHandler = new GMap.Markers @googleMaps
      @markerHandler.makeMarkers @markerData
      @markerHandler.addMarkersToMap(map)
      @revealDynamicMap()

      unless @$locationsModal.hasClass 'show-modal'
        @$locationsModal.css
          display: ''
          visibility: ''
      @isDynamicMapsWasActivated = true

  createDynamicMap: (options) ->
    mapOptions = @buildMapOptions options

    new @googleMaps.Map @$dynamicMap[0], mapOptions

  revealDynamicMap: ->
    @$dynamicMap.each ->
      $dynamicMap = $(this)
      $staticMap = $dynamicMap.siblings '.static-map'

      if $staticMap.length
        $dynamicMap.css
          height: $staticMap.height()
          width: $staticMap.width()

    @$staticMap.hide()
    @$dynamicMap.show()
    GMap.vent.trigger 'dynamicMapRevealed'

  buildMapOptions: (mapOptions) ->
    mapOptions.center = new @googleMaps.LatLng(mapOptions.center.lat, mapOptions.center.lng)
    mapOptions.mapTypeId = @googleMaps.MapTypeId.ROADMAP

    mapOptions

  onLocationsPopupOpen: () ->
    if not @isLocationsPopupWasActivated and @isDynamicMapsWasActivated
      @isLocationsPopupWasActivated = true
      GMap.vent.once('start', => @start())
      @changeToDynamic()

module.exports = GMap.View
